import React from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  selectCurrentModal,
  selectModalTab,
  setModalTab,
} from "../../../store/slices/modalsSlice";
import ReportingTopics from "../../../Reporting/ReportingTopics.tsx";
import ReportingTemplates from "../../../Reporting/ReportingTemplates.tsx";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";

export default function ReportingModal() {
  const dispatch = useDispatch();
  const show = useSelector(selectCurrentModal) === "reports";
  const tab = useSelector(selectModalTab);
  const setTab = (t) => dispatch(setModalTab(t));
  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      size="xl"
      show={show}
      onHide={handleClose}
      scrollable
      fullscreen="xxl-down"
      className="contacts-modal"
      backdropClassName="contacts-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="icon fa fa-edit" />
          <FontAwesomeIcon icon={faUserPlus} /> Reporting
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs
          id="uncontrolled-reporting-tab-contacts"
          className="mb-3"
          unmountOnExit
          activeKey={tab}
          onSelect={(key) => {
            setTab(key);
          }}
        >
          <Tab eventKey="topics" title="Topics">
            <div className="row align-items-stretch" style={{ minHeight: 400 }}>
              <ReportingTopics inModal />
            </div>
          </Tab>
          <Tab eventKey="templates" title="Templates">
            <div className="row align-items-stretch" style={{ minHeight: 400 }}>
              <ReportingTemplates inModal />
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
}
